var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListArrow = function SvgListArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 13 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F89723",
    d: "m2 0 11 11L2 22l-2-2 9-9-9-9z"
  })));
};
export { SvgListArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMEwxMyAxMUwyIDIyTDAgMjBMOSAxMUwwIDJMMiAwWiIgZmlsbD0iI0Y4OTcyMyIvPgo8L3N2Zz4K";